module.exports = __webpack_public_path__ + "img/p18.7f1a55b3.png";